/**
 * @fileoverview Score Controller - スコア表示管理
 */

import { getScore } from '../../gameplay/scoring.js';

import { onPathChange } from './subscription-utils.js';

/**
 * スコア表示のDOM更新
 * 純粋関数: DOM操作のみ、状態変更なし
 */
export function updateScoreDisplay(_gameState) {
  const scoreElement = document.getElementById('score-value');
  if (!scoreElement) return; // スコア表示要素がない場合は何もしない

  const currentScore = getScore();
  const formattedScore = Number(currentScore || 0).toLocaleString();

  // 値が変更された場合のみ更新（パフォーマンス最適化）
  if (scoreElement.textContent !== formattedScore) {
    scoreElement.textContent = formattedScore;
  }

  // Score display updated - no logging needed
}

/**
 * スコアコントローラーの初期化
 * GameStateの変更を監視してスコア表示を自動更新
 */
export function initializeScoreController(gameState) {
  // スコア変更のみを監視（境界バグ回避版）
  return onPathChange(
    gameState,
    'game.score',
    () => {
      updateScoreDisplay(gameState);
    },
    true,
  );
}
